import http from '@/plugins/http';

import { useAuthStore } from '@/stores/auth';
import reportError from '@/utils/reportError';
import accountService from '../account';

// When the request succeeds
const success = (token, onSuccessCallback) => {
  useAuthStore().login(token);
  accountService.find();
  onSuccessCallback();
};

// When the request fails
const failed = (error, onFailureCallback) => {
  onFailureCallback(error);
};

export default (token, password, onFailureCallback, onSuccessCallback) => {
  const data = {
    password,
  };
  http.put(`user/${token}/password`, data)
    .then((response) => {
      success(response.data.access_token, onSuccessCallback);
    })
    .catch((error) => {
      reportError(error, 'error trying to update user password');
      failed(error, onFailureCallback);
    });
};
